module.exports = __webpack_public_path__ + "static/media/Inter-Thin.dbd13499.ttf";